import { NEXT_PUBLIC_PARTNER_URL } from 'utils/env';

export default function isPartnerHost(host) {
  if (!NEXT_PUBLIC_PARTNER_URL) return false;

  return host === new URL(NEXT_PUBLIC_PARTNER_URL).host;
}
